import React from 'react';

function ListContacts(props) {
	const items = [
			{
					link: 'mailto:patel24111@gmail.com',
					icon: 'fas fa-envelope fa-lg animated fadeIn delay-2s'
			},
			{
					link: 'https://github.com/akshayrpatel',
					icon: 'fab fa-github fa-lg animated fadeIn delay-2s'
			},
			{
					link: 'https://www.linkedin.com/in/akshayrpatel/',
					icon: 'fab fa-linkedin fa-lg animated fadeIn delay-2s'
			}
	]

	const iconClass = "icon has-text-" + props.color + ' ' + props.hover
	const listItems = items.map((item, index) => {
			return( 
					<li key={index} className="padding-one-top padding-one-bottom">
							<a href={item.link}>
									<span className={iconClass}>
											<i className={item.icon}></i>
									</span>
							</a>
					</li>
			)
	})

	return(
			<ul>
					{listItems}
			</ul>
	)
}

const Contact = () => {
	return (
		<div id="contact" className="Contact">

			<div className="column has-text-centered">
				<p className="title is-5 is-blue has-text-bold is-heading padding-two-top">CONTACT</p>
			</div>
			<div className="column has-text-centered">
				<p className="subtitle is-3 has-text-white has-text-bold">
					Let's get in touch
				</p>
			</div>

			<div className="">
				<div className="card has-background-black">
					<div className="card-content">
						<div className="content">
							<div className="column has-text-white has-text-centered">
								<p className="is-size-1 is-blue"><i className='fas fa-envelope fa-lg'></i></p>
							</div>
							<div className="column has-text-white has-text-centered">
								<p className="is-size-6 has-text-weight-bold">EMAIL ME AT</p>
								<p className="has-text-weight-light"><a id="email" className="has-text-grey-light" href="mailto:patel24111@gmail.com">patel24111@gmail.com</a></p>
							</div>
							<div className="column has-text-white has-text-centered">
								<p className="is-size-6 has-text-weight-light"></p>
							</div>
						</div>
					</div>
				</div>
			</div>

		  <div className="container">
				<div className="column has-text-centered">
					<nav className="breadcrumb is-centered has-text-white has-bullet-separator" aria-label="breadcrumbs">
						Designed by Akshay Patel
					</nav>
				</div>
		  </div>
		</div>
	);
};

export {
	ListContacts,
	Contact
}